export const APP_LOADED_SUCCESS = 'APP/APP_LOADED_SUCCESS';
export const APP_SETUP = 'APP/APP_SETUP';
export const APP_RESET = 'APP/APP_RESET';


export const ERROR = 'APP/ERROR';
export const CLEAR_ERRORS = 'APP/CLEAR_ERRORS';
